module.exports = __webpack_public_path__ + "media/src/website/images/locations/kufstein/profile-54bb0dc673a13a3be6f5003a64b0fa1b.jpg";